import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
/** El contorno del cuerpo. Seis lados, esquinas suavizadas, en una caja de 120. */
export const MASCOT_OUTLINE_PATH = 'M106.75 45.71 C111.31 53.60 111.31 66.40 106.75 74.29 L95.75 93.34 C91.19 101.23 80.11 107.63 71.00 107.63 '
    + 'L49.00 107.63 C39.89 107.63 28.81 101.23 24.25 93.34 L13.25 74.29 C8.69 66.40 8.69 53.60 13.25 45.71 '
    + 'L24.25 26.66 C28.81 18.77 39.89 12.37 49.00 12.37 L71.00 12.37 C80.11 12.37 91.19 18.77 95.75 26.66 Z';
/**
 * Lo que mide el contorno de ancho, en las unidades del trazado.
 *
 * Es el divisor que convierte «quiero un anillo de 340 de ancho» en una escala.
 * Sin él habría que pensar en factores, y los tamaños dejarían de leerse como lo
 * que son —píxeles en pantalla— en cuanto alguien tocara el trazado.
 */
export const MASCOT_OUTLINE_BASE_WIDTH = 102.62;
/**
 * Los anillos: el mismo contorno a tamaños crecientes, todos desde un centro.
 *
 * Van dentro de un `<svg>` que pone el `viewBox` y el color; esto sólo dibuja.
 * El trazo es de un píxel a cualquier escala —`non-scaling-stroke`—: sin eso,
 * los anillos de fuera saldrían con la línea diez veces más gorda que los de
 * dentro y el patrón dejaría de leerse como un eco.
 */
export function MascotRings({ center, sizes, opacity, strokeWidth = 1, motion }) {
    const [centerX, centerY] = center;
    return (_jsx(_Fragment, { children: sizes.map((size, index) => motion ? (
        /* Capas separadas: el centro no se anima, sólo la escala. Así la
           distancia recorrida sale de `size + step`, no de multiplicar todo el
           patrón —que hacía que los anillos grandes corrieran más deprisa. */
        _jsx("g", { transform: `translate(${centerX} ${centerY})`, children: _jsx("g", { className: motion.className, transform: `scale(${size / MASCOT_OUTLINE_BASE_WIDTH})`, style: {
                    '--mascot-ring-from': size / MASCOT_OUTLINE_BASE_WIDTH,
                    '--mascot-ring-to': (size + motion.step) / MASCOT_OUTLINE_BASE_WIDTH,
                    '--mascot-ring-duration': `${motion.durationMs}ms`,
                }, children: _jsx("path", { d: MASCOT_OUTLINE_PATH, fill: "none", stroke: "currentColor", strokeWidth: strokeWidth, strokeLinejoin: "round", vectorEffect: "non-scaling-stroke", opacity: opacity(index), transform: "translate(-60 -60)" }) }) }, size)) : (_jsx("path", { d: MASCOT_OUTLINE_PATH, fill: "none", stroke: "currentColor", strokeWidth: strokeWidth, strokeLinejoin: "round", vectorEffect: "non-scaling-stroke", opacity: opacity(index), 
            /* Al centro primero, luego la escala y por último el propio contorno a
               su origen: al revés, escalar movería el centro y cada anillo saldría
               desplazado del anterior. */
            transform: `translate(${centerX} ${centerY}) scale(${size / MASCOT_OUTLINE_BASE_WIDTH}) translate(-60 -60)` }, size))) }));
}
//# sourceMappingURL=MascotPattern.js.map